module.exports = __webpack_public_path__ + "static/media/mihai.7bf0fad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/mihai.jpg
// module id = 328
// module chunks = 0